import Vue from 'vue';
import { vMaska } from 'maska';
Vue.directive('maska', vMaska);
